import script from "./ProductCourseCommentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCourseCommentDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProductCourseCommentDialog.vue?vue&type=style&index=0&id=5a8efb0c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8efb0c"]])

export default __exports__